import React from 'react';
import ViewsProvider from '../../../../../utils/components/ViewsProvider';
import views from './views';

const CustomizationItems = () => <ViewsProvider views={views} />;

export default CustomizationItems;
